'use client'

import { queryKeys } from '@/shared/api/react-query'
import { useQuery } from '@tanstack/react-query'
import services from '../services'

const useGetUploadFileTypes = () => {
  const queryKey = [queryKeys((a, m, p) => a.uploadFileType.getUploadFileTypes() + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      const res = await services.getUploadFileTypes()
      if (res) return res
      return []
    },
  })

  return {
    ...query,
    queryKey,
    data: query.data || [],
  }
}

export default useGetUploadFileTypes
